
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator'

    @Component
    export default class AppendixName extends Vue {
        @Prop({ default: '' }) fileName!: string;
        suffix = ''
        name = ''

        @Watch('fileName')
        changeFileName (val: string) {
            this.name = val
            this.suffix = this.getSuffix(val)
        }

        created () {
            this.name = this.fileName
            this.suffix = this.getSuffix(this.fileName)
        }

        get fileIcon () {
            let icon = ''
            switch (this.suffix) {
                case 'pdf':
                    icon = 'icon-pdf'
                    break
                case 'word':
                    icon = 'icon-word'
                    break
                case 'excel':
                case 'xlsx':
                    icon = 'icon-excel'
                    break
                case 'txt':
                    icon = 'icon-txt'
                    break
                case 'jpg':
                case 'jpeg':
                    icon = 'icon-jpg'
                    break
                case 'png':
                    icon = 'icon-png'
                    break
                case 'gif':
                    icon = 'icon-gif'
                    break
                case 'rar':
                case 'zip':
                    icon = 'icon-zip'
                    break
                case 'bmp':
                    icon = 'icon-txt'
                    break
                default:
                    icon = 'icon-txt'
                    break
            }
            return icon
        }

        /* 支持上传PDF、Word、Excel、Txt、JPG、PNG、BMP、GIF、RAR、ZIP格式 */
        /* 获取文件后缀名 */
        getSuffix (name: string) {
            return name.substring(name.lastIndexOf('.') + 1).toLocaleLowerCase()
        }
    }
